<div class="search">
    <app-search-and-filter></app-search-and-filter>
</div>
<div class="container">
    <app-spinner [isLoading]="isLoading$ | async" [isWithSearchPanel]="true">
        @if ({
                topBanner: frontPageTopBanner$ | async,
                bottomBanner: frontPageBottomBanner$ | async,
                providerWebsiteUrlMap: providerWebsiteUrlMap$ | async,
                userType: userType$ | async,
                favoriteAnnouncements: favoriteAnnouncements$ | async,
                isLoading: isLoading$ | async };
                as data) {
            <div class="content">

                <!-- Top Banner -->
                <div style="margin-top: 1.25rem;" class="banner">
                    <app-banner [banner]="data.topBanner" [pageId]="pageId.FrontPage"></app-banner>
                </div>

                <!-- Favourite Announcement List-->
                <div class="ann-list">
                    @for (announcement of data.favoriteAnnouncements; track announcement.announcementId) {
                        <app-announcement-item
                            [announcement]="announcement" [providerWebsiteUrlMap]="data.providerWebsiteUrlMap" [date]="date" [providerWebsiteId]="providerWebsiteId" [userType]="data.userType">
                        </app-announcement-item>
                    } @empty {
                        @if (!data.isLoading) {
                            <div class="empty">
                                <!-- outlines of the tiles that would be listed here -->
                                <div class="empty__ghosts" aria-hidden="true">
                                    @for (ghost of [1, 2]; track ghost) {
                                        <div class="ghost">
                                            <span class="ghost__lines">
                                                <span class="ghost__line ghost__line--title"></span>
                                                <span class="ghost__line"></span>
                                            </span>
                                            <svg-icon
                                                [svgClass]="'ghost__heart'"
                                                [src]="'assets/icons/fav-icon-' + providerWebsiteId + '.svg'">
                                            </svg-icon>
                                        </div>
                                    }
                                </div>

                                <span class="empty__icon">
                                    <svg-icon
                                        [svgClass]="'empty__fav'"
                                        [src]="'assets/icons/fav-icon-grey-filled-' + providerWebsiteId + '.svg'">
                                    </svg-icon>
                                </span>
                                <h2 class="empty__title">{{ 'label.NoFavoritesTitle' | translate }}</h2>
                                <p class="empty__text">{{ 'label.NoFavoritesDescription' | translate }}</p>
                                <a class="empty__action" [routerLink]="['/']">{{ 'label.ViewAllAnnouncements' | translate }}</a>
                            </div>
                        }
                    }
                </div>

                <!-- Bottom Banner -->
                <div class="banner">
                    <app-banner [banner]="data.bottomBanner" [pageId]="pageId.FrontPage"></app-banner>
                </div>
            </div>
        }
    </app-spinner>
</div>
